import React, { useContext, useState, useEffect } from "react";
import { StateContext } from "../../../context/StateContext";
import Loading from "../../../components/loading/loading";
import Logs from "./Logs";
import Header from "../../../components/header/header";

const CHANNELS_COUNT = 14;
const MIN_BELL = 1;
const MAX_BELL = 14;

const parseChannel = (value, index) => {
  if (value === undefined || value === null || value === "") {
    return index + 1;
  }

  const parsed = typeof value === "number" ? value : parseInt(value, 16);

  if (Number.isNaN(parsed) || parsed < MIN_BELL) {
    return index + 1;
  }

  if (parsed > MAX_BELL) {
    return MAX_BELL;
  }

  return parsed;
};

const Channels = () => {
  const STATE = useContext(StateContext);
  const [channels, setChannels] = useState([]);

  useEffect(() => {
    const source = STATE.lastData.channels || [];
    const nextChannels = [];

    for (let i = 0; i < CHANNELS_COUNT; i++) {
      nextChannels.push(parseChannel(source[i], i));
    }

    setChannels(nextChannels);
  }, []);

  const changeChannel = (index, move) => {
    const nextChannels = [...channels];
    const value = nextChannels[index];

    if (move === "dec" && value > MIN_BELL) {
      nextChannels[index] = value - 1;
    }

    if (move === "inc" && value < MAX_BELL) {
      nextChannels[index] = value + 1;
    }

    setChannels(nextChannels);
  };

  const save = () => {
    STATE.sendData({ channels });
  };

  const channelsList = channels.map((bell, index) => (
    <div className="force-item" key={index}>
      <div className="force-num">№ {index + 1}</div>
      <div className="force-count-area">
        <div className="dec" onClick={() => changeChannel(index, "dec")}>
          -
        </div>
        <div className="count">{bell}</div>
        <div className="inc" onClick={() => changeChannel(index, "inc")}>
          +
        </div>
      </div>
    </div>
  ));

  return (
    <div className="main-area-field full-height">
      <div className="main-area full-height">
        <div className="page-area no-p">
          <Header
            title={"Каналы"}
            backTitle="Настройки"
            backUrl={`/device/${STATE.subscribed.id}/settings`}
          />
          <Logs />

          <div className="page-area center-h">
            <div className="content">
              <div className="block force-block">
                <div className="force-list-header">
                  <div className="force-num">Канал</div>
                  <div className="force-count-label">Номер колокола</div>
                </div>
                <div className="force-list _channels">{channelsList}</div>
              </div>
              <div className="button-area _center">
                <button
                  className="btn btn-yellow chimes-save"
                  onClick={save}
                >
                  {!STATE.isSending && "СОХРАНИТЬ"}
                  {STATE.isSending && <Loading />}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Channels;
